import React from "react";
import { Badge, ProgressBar } from "react-bootstrap";

const CountdownTimer = ({
  remainingSeconds,
  totalMinutes,
  variant = "primary",
  showProgressBar = true,
  size = "sm",
  className = "",
}) => {
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs.toString().padStart(2, "0")}`;
  };

  const getVariant = () => {
    if (remainingSeconds <= 30) return "danger";
    if (remainingSeconds <= 60) return "warning";
    return variant;
  };

  const getProgressVariant = () => {
    if (remainingSeconds <= 30) return "danger";
    if (remainingSeconds <= 60) return "warning";
    return "success";
  };

  const progressPercentage = Math.max(
    0,
    (remainingSeconds / (totalMinutes * 60)) * 100,
  );

  return (
    <>
      <div className={`countdown-timer ${className}`}>
        <div className="d-flex align-items-center justify-content-center mb-2">
          <Badge
            bg={getVariant()}
            className={`me-2 ${size === "lg" ? "fs-6" : ""}`}
          >
            <i className="mdi mdi-timer-outline me-1"></i>
            {formatTime(remainingSeconds)}
          </Badge>
          {remainingSeconds <= 60 && (
            <small className="text-muted">
              {remainingSeconds <= 30
                ? "¡Tiempo casi agotado!"
                : "Poco tiempo restante"}
            </small>
          )}
        </div>

        {showProgressBar && (
          <ProgressBar
            now={progressPercentage}
            variant={getProgressVariant()}
            style={{ height: "6px" }}
            className="mb-2"
          />
        )}

        <div className="text-center">
          <small className="text-muted">
            Tiempo restante para escanear el QR
          </small>
        </div>
      </div>

      <style jsx>{`
        .countdown-timer {
          background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
          border-radius: 8px;
          padding: 15px;
          border: 1px solid #dee2e6;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
        }

        .countdown-timer .badge {
          font-size: 0.85rem;
          padding: 8px 12px;
          font-weight: 600;
          letter-spacing: 0.5px;
          animation: pulse 2s infinite;
        }

        @keyframes pulse {
          0% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.05);
          }
          100% {
            transform: scale(1);
          }
        }

        .countdown-timer .progress {
          border-radius: 10px;
          overflow: hidden;
          background-color: rgba(0, 0, 0, 0.1);
        }

        .countdown-timer .progress-bar {
          transition: width 1s ease-in-out;
          border-radius: 10px;
        }

        .countdown-timer small {
          font-size: 0.75rem;
          opacity: 0.8;
        }
      `}</style>
    </>
  );
};

export default CountdownTimer;
